module.exports = __webpack_public_path__ + "static/media/note-arrow-up.c0203a14.svg";